export const TEXTS = {
  TRACK_LOADING: 'Треки загружаются',
  NO_DEVICE: 'Загрузка треков начнется после привязки устройства',
};
